export default class LoadingSpinner {
    constructor(buttons, container) {
        this.buttons =
            buttons ??
            document.querySelectorAll(
                '.js-products-sort-bar form button[type="submit"]'
            );
        this.container =
            container ?? document.querySelector('.js-products-sort-bar > div');

        if (!this.container) return;

        this.bindEvents = this.bindEvents.bind(this);
        this.init = this.init.bind(this);
        this.init();
    }

    bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this.container.classList.add('js-loading');
            });
        });
    }

    init() {
        this.bindEvents();
    }
}

new LoadingSpinner();
